h1 {

}
.explanation {
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 2em;

}

.startConversionButtonLine {
  margin-top: .7em;
  text-align: right;
}
